import styled from "styled-components";
import { rem } from "convert-to-ems";

export const Overlayer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0;
  left: 0;
  overflow: hidden;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  @media (${props => props.theme.breakpoints.mobile}) {
    background-color: ${props => props.mobileBackgroundColor};
  }
`;

export const Wrapper = styled.div`
  background-color: ${props => props.theme.baseColor};
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  border-radius: ${rem(6)};
  width: ${props => rem(props.width)};
  height: ${props => rem(props.height)};

  @media (${props => props.theme.breakpoints.mobile}) {
    border-radius: ${props => rem(props.mobileBorderRadius)};
    width: ${props => props.mobileWidth};
    height: ${props => props.mobileHeight};
  }
`;

export const BtnClose = styled.button`
  font-size: ${rem(30)};
  color: #000;
  opacity: 0.3;
  cursor: pointer;
  border: none;
  background-color: ${props => props.theme.baseColor};
`;

export const Content = styled.div`
  position: ${props => (props.position === "none" ? "" : props.position)};
  ${props => (props.contentHeightPercent ? `height: ${props.contentHeightPercent}` : "")};
  margin: ${props => rem(props.contentMargin)};
  max-width: ${props => rem(props.contentMaxWidth)};
  padding-top: ${props => rem(props.contentPaddingTop)};
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.contentJustifyContent};
  align-items: ${props => props.contentAlignItems};
  color: #010000;
  cursor: auto;

  @media (${props => props.theme.breakpoints.mobile}) {
    padding-top: ${props => rem(props.contentPaddingTopMobile)};
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: ${rem(5)};
`;
